<template>
    <div>
        <div class="breadcrumb">
            <h1 style="color: #AC8400;">Approved Claims</h1>
        </div>

        <!-- Breadcrumbs -->
        <div style="padding: 10px; background-color: #F2F2F2">
            <router-link to="/dashboard">Dashboard</router-link> /
            <b>TBA</b> /
            <b>Approved Claims</b>
        </div>
        <!-- End of breadcrumbs -->

        <div class="separator-breadcrumb border-top"></div>

        <div class="card text-left">
            <div class="card-body">
                <h4 class="card-title mb-3">Approved Claims</h4>
                <div class="mb-3">
                    <button class="btn btn-secondary" :class="{ active: activeApprovedStatus === '' }" @click="
                        filterApprovedClaims('');
                    activeApprovedStatus = '';
                    ">
                        All
                    </button>
                    <button class="btn btn-secondary" :class="{ active: activeApprovedStatus === 'Pending' }" @click="
                        filterApprovedClaims('Pending');
                    activeApprovedStatus = 'Pending';
                    ">
                        Pending
                    </button>
                    <button class="btn btn-secondary" :class="{ active: activeApprovedStatus === 'Submitted' }" @click="
                        filterApprovedClaims('Submitted');
                    activeApprovedStatus = 'Submitted';
                    ">
                        Submitted
                    </button>
                    <button class="btn btn-secondary" :class="{ active: activeApprovedStatus === 'Paid' }" @click="
                        filterApprovedClaims('Paid');
                    activeApprovedStatus = 'Paid';
                    ">
                        Paid
                    </button>
                </div>
                <div>
                </div>
                <div class="mb-3 d-flex justify-content-between">
                    <div>
                        <button class="btn btn-primary btn-rounded" style="padding: 8px 60px;"
                            id="exportExcel">Excel</button>
                    </div>
                    <div>
                        <button class="btn btn-primary btn-rounded" style="padding: 8px 30px;"
                            @click="openFilterModal()">Filter</button>
                    </div>
                </div>
                <div>
                    <div>
                        <button class="btn btn-primary" @click="openMarkAsPaidModal()">
                            Mark as Paid
                        </button>
                        <small style="color: red; display: block;">*Note: Available only on Submitted status</small>
                    </div>

                </div>

                <div class="table-responsive" style="">
                    <table id="approved_claim_tbl" class="display table table-striped table-bordered"
                        style=" text-align: center; min-width: 4000px;">
                        <thead>
                            <tr>
                                <th width="300" class="">
                                    <div>
                                        <input class="mr-4 custom-checkbox" type="checkbox" v-model="selectAll"
                                            @change="toggleSelectAll" />
                                        <span style="text-align: left;">IC Number</span>
                                    </div>
                                </th>
                                <th width="1000">Name</th>
                                <th width="200">Status</th>
                                <th width="400">Incident Date</th>
                                <th width="400"><span>Submission Date </span><span>
                                        <Tooltip position="bottom">Refers to document submission date.
                                        </Tooltip>
                                    </span></th>
                                <th width="300">Notification Date</th>
                                <th width="400">Type of Payment</th>
                                <th width="400">Musafir Certificate No.</th>
                                <th width="200">Reference ID No.</th>
                                <th width="200">IC Photo</th>
                                <th width="500">Bank Details</th>
                                <th width="400"><span>Bank Submission</span><span>
                                        <Tooltip position="bottom">Refers to the bank details submission date by
                                            customer.
                                        </Tooltip>
                                    </span></th>
                                <th width="500">Approved Date</th>
                                <th width="500">Paid Date</th>
                                <th width="300">Amount in B$</th>
                                <th width="600">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="approved_claims.length === 0">
                                <td colspan="16" class="text-center">No Data Available</td>
                            </tr>
                            <tr v-for="(claim, index) in approved_claims" :key="index">
                                <td>
                                    <input class="mr-4 custom-checkbox" type="checkbox" :value="claim.id"
                                        v-model="selectedItems" :disabled="!isSubmitted(claim)" />
                                    <span style="text-align: left;">{{
                                        claim.user.ic_number
                                        }}</span>
                                </td>
                                <td>{{ claim.user.name }}</td>
                                <td style="color: green; font-weight: 600;">{{ claim.payment_type.id === 2 &&
                                    claim.status === 'Paid' ? 'Collected' : claim.status }}</td>
                                <td>{{ claim.incident_date }}</td>
                                <td>{{ claim.submission_date }}</td>
                                <td>{{ claim.notification_date }}</td>
                                <td>{{ claim.payment_type.name }}</td>
                                <td>{{ claim.certificate_no }}</td>
                                <td>{{ claim.reference_no }}</td>
                                <td v-if="claim.ic_upload">
                                    <div v-if="claim.ic_upload">
                                        <button class="btn btn-primary btn-rounded btn-block"
                                            @click="openImage(claim.ic_upload)">
                                            View Details
                                        </button>
                                    </div>
                                </td>
                                <td v-else>
                                    -
                                </td>
                                <td style="max-width: 500px;">
                                    <span>
                                        {{ claim.account_holder }}
                                        <br />
                                        {{ claim.bank_name }}
                                        <br />
                                        {{ claim.account_number }}
                                    </span>
                                </td>
                                <td>
                                    {{ claim.submission_date }}
                                </td>
                                <td>{{ claim.approved_at }}</td>
                                <td>{{ claim.payment_date }}</td>
                                <!-- <td>
                                    <a v-if="claim.status !== 'Pending'"
                                        class="btn btn-primary btn-rounded btn-block text-white"
                                        :href="claim.ic_upload">
                                        View Details</a>
                                </td>
                                <td>
                                    <a v-if="claim.status !== 'Pending'"
                                        class="btn btn-primary btn-rounded btn-block text-white"
                                        :href="claim.bank_upload">
                                        View Details</a>
                                </td> -->
                                <td>{{ claim.amount }}</td>
                                <td>
                                    <div class="d-flex justify-content-center">
                                        <button type="button" class="btn btn-primary btn-rounded  mr-2"
                                            style="width: 150px;" @click="openPaymentDateModal(claim)"
                                            v-if="claim.status == 'Submitted'">
                                            Set Date
                                        </button>
                                        <button type="button" class="btn btn-outline-primary btn-rounded "
                                            style="width: 150px;" @click="openRequestChangeModal(claim)"
                                            v-if="claim.status == 'Submitted'">Request
                                            Change
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div v-if="isOpenModal" class="modal fade" :class="{ show: isOpenModal }" id="exampleModal" tabindex="-1"
            role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="false"
            style="display: block; background-color: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content p-4">
                    <div class="modal-body text-center">
                        <h5 class="modal-title text-primary mb-3" id="modal-title">
                            {{ editData.payment_type.name == 'Cash Collection' ? 'Date Cash Collected' : 'Paid Date' }}
                        </h5>

                        <div class="form-group text-left px-3 py-2">
                            <label for="payment_method">Payment Method</label>
                            <input type="text" id="payment_method" v-model="editData.payment_type.name"
                                class="form-control" value="Bank Transfer" disabled />
                        </div>
                        <div class="form-group text-left px-3 py-2">
                            <label for="date_paid">
                                {{ editData.payment_type.name == 'Cash Collection' ? 'Date Cash Collected' : 'Date Paid'
                                }}
                            </label>
                            <input type="date" id="date_paid" v-model="datePaid" @change="handleDateChange"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="d-flex justify-content-center px-3 py-2">
                        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                            @click="isOpenModal = false">
                            Close
                        </button>
                        <button type="button" class="btn btn-primary" @click="handleSubmit">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="requestChangeModal" class="modal fade" :class="{ show: requestChangeModal }" id="requestChangeModal"
            tabindex="-1" role="dialog" aria-labelledby="requestChangeLabel" aria-hidden="false"
            style="display: block; background-color: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content p-4">
                    <div class="modal-body text-center">
                        <h5 class="modal-title text-primary mb-3" id="modal-title">
                            Request Change
                        </h5>

                        <p>Confirm to send a request to the user to switch the settlement method from {{
                            editData.payment_type.name }} to
                            {{ editData.payment_type.name == 'Online Transfer' ? 'Cash Collection' : 'Online Transfer'
                            }}
                        </p>
                    </div>
                    <div class="d-flex justify-content-center px-3 py-2">
                        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                            @click="requestChangeModal = false">
                            Close
                        </button>
                        <button type="button" class="btn btn-primary" @click="handleRequestChange">
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="successModal" class="modal fade" :class="{ show: successModal }" id="successModal" tabindex="-1"
            role="dialog" aria-labelledby="successModalLabel" aria-hidden="false"
            style="display: block; background-color: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content p-4">
                    <div class="modal-body text-center">
                        <h5 class="modal-title text-primary mb-3" id="modal-title">
                            Payment Method Updated
                        </h5>
                        <p>The request has been notified to user.</p>
                    </div>
                    <div class="d-flex justify-content-center px-3 py-2">
                        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                            @click="successModal = false">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="filterModal" class="modal fade" :class="{ show: filterModal }" id="filterModal" tabindex="-1"
            role="dialog" aria-labelledby="filterModalLabel" aria-hidden="false"
            style="display: block; background-color: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content p-4">
                    <div class="modal-body text-center">
                        <h5 class="modal-title text-primary mb-3" id="modal-title">
                            Filter Payment Date
                        </h5>
                        <div class="row">
                            <div class="col-6">
                                <TextInput label="Date from:" type="date" :modelValue="date_from" required
                                    :errorMessage="fromMessage" :onChange="(e) => onChangeDate(e, 'from')" />
                            </div>
                            <div class="col-6">
                                <TextInput label="Date to:" type="date" :modelValue="date_to" required
                                    :errorMessage="toMessage" :onChange="(e) => onChangeDate(e, 'to')" />
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center px-3 py-2">
                        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                            @click="filterModal = false">
                            Close
                        </button>
                        <button type="button" class="btn btn-primary" @click="handleFilter">
                            Filter
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isMarkAsPaid" class="modal fade" :class="{ show: isMarkAsPaid }" id="isMarkAsPaid" tabindex="-1"
            role="dialog" aria-labelledby="isMarkAsPaidLabel" aria-hidden="false"
            style="display: block; background-color: rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content p-4">
                    <div class="modal-body text-center">
                        <h5 class="modal-title text-primary mb-3" id="modal-title">
                            Mark As Paid
                        </h5>
                        <div class="form-group text-left px-3 py-2">
                            <label for="date_paid">Date Paid</label>
                            <input type="date" id="date_paid" v-model="datePaid" @change="handleDateChange"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="d-flex justify-content-center px-3 py-2">
                        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                            @click="isMarkAsPaid = false">
                            Close
                        </button>
                        <button type="button" class="btn btn-primary" @click="handleMarkAsPaid">
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getApproveClaim, markAsPaid, requestChange, updatePaymentDate } from '../../../services/ClaimService';
import Tooltip from '../../../components/UI/Tooltip.vue';
import TextInput from '../../../components/TextInput.vue';
import axios from 'axios';
import { getRequest } from '../../../services/RequestService';

export default {
    name: "approved-claims",
    components: {
        Tooltip,
        TextInput
    },

    data() {
        return {
            pending_approved_claims: [],
            paid_approved_claims: [],
            submitted_approved_claims: [],
            all_approved_claims: [],
            approved_claims: [],
            selectedItems: [],
            selectAll: false,
            activeApprovedStatus: "",
            isOpenModal: false,
            requestChangeModal: false,
            editData: null,
            isMarkAsPaid: false,
            successModal: false,
            filterModal: false,
            date_from: null,
            date_to: null,
            fromMessage: '',
            toMessage: '',
        };
    },

    watch: {
        selectedItems(newVal) {
            const allSubmittedIds = this.approved_claims
                .filter(claim => this.isSubmitted(claim))
                .map(claim => claim.id);

            this.selectAll = newVal.length === allSubmittedIds.length;
        }
    },

    methods: {
        async fetchApproveClaim(date_from, date_to) {

            const request = date_from && date_to ? {
                date_from,
                date_to
            } : {};

            try {
                const response = await getApproveClaim(request);

                if (response.data.success) {
                    const { paid, pendings, submitted } = response.data.data;
                    this.pending_approved_claims = pendings || [];
                    this.paid_approved_claims = paid || [];
                    this.submitted_approved_claims = submitted || [];
                    this.all_approved_claims = [...(pendings || []), ...(paid || []), ...(submitted || [])];
                    this.approved_claims = this.all_approved_claims;
                    this.filterModal = false;
                    this.activeApprovedStatus = ""
                    this.filterApprovedClaims('')
                    this.$nextTick(() => {
                        this.initializeApprovedClaimsDatatable();
                    });
                }
            } catch (error) {
                console.error(error);
            }
        },

        async openImage(ic_upload) {
            try {
                const response = await getRequest(ic_upload, { responseType: 'blob' });

                console.log(response)

                if (response.status !== 200) throw new Error('Failed to fetch IC Upload');

                const blob = response.data;

                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                // link.setAttribute('download', 'ic_upload');
                document.body.appendChild(link);
                link.click();
                link.remove();

                // 4. Preview in new tab
                window.open(url, '_blank');

            } catch (err) {
                console.error(err);
                alert('Failed to open ic upload');
            }
        },

        validateDate(date_from, date_to) {
            // Check if dates are provided
            if (!date_from) {
                this.fromMessage = "Start date is required.";
                return false;
            }
            if (!date_to) {
                this.toMessage = "End date is required.";
                return false;
            }

            const from = new Date(date_from);
            const to = new Date(date_to);

            // Check valid date format
            if (isNaN(from.getTime())) {
                this.fromMessage = "Invalid start date format.";
                return false;
            }
            if (isNaN(to.getTime())) {
                this.toMessage = "Invalid end date format.";
                return false;
            }

            // Check date order
            if (from > to) {
                this.fromMessage = "Start date cannot be greater than end date.";
                return false;
            }

            // const today = new Date();
            // if (from > today) {
            //     this.fromMessage = "Start date cannot be in the future.";
            //     return false;
            // }
            // if (to > today) {
            //     this.toMessage = "End date cannot be in the future.";
            //     return false;
            // }

            return true;
        },


        handleFilter() {
            if (this.validateDate(this.date_from, this.date_to)) {
                this.fromMessage = '';
                this.toMessage = '';
                this.fetchApproveClaim(this.date_from, this.date_to);
            }
        },

        toggleSelectAll() {
            if (this.selectAll) {
                this.selectedItems = this.approved_claims
                    .filter(claim => this.isSubmitted(claim))
                    .map(claim => claim.id);
            } else {
                this.selectedItems = [];
            }
        },

        initializeApprovedClaimsDatatable() {
            const $table = $('#approved_claim_tbl');

            // 1. Ensure table exists in DOM
            if (!$table.length) {
                console.warn('DataTable init failed: Table not found in DOM');
                return;
            }

            // 2. Ensure table has rows
            if ($table.find('tbody tr').length === 0) {
                console.warn('DataTable init failed: No rows in tbody');
                return;
            }

            // 3. Destroy existing instance cleanly
            if ($.fn.DataTable.isDataTable($table)) {
                $table.DataTable().destroy();
            }

            // 4. Reinitialize with safe options
            try {
                this.datatable = $table.DataTable({
                    destroy: true,        // Allow re-init
                    retrieve: true,       // Don't throw error if already initialized
                    pageLength: 10,
                    dom: "Bfrtip",
                    autoWidth: false,
                    buttons: [
                        {
                            extend: "excelHtml5",
                            title: "Approved Claims",
                            exportOptions: {
                                columns: ':not(:last-child)' // Exclude Action
                            }
                        }
                    ]
                });

                // 5. Rebind export button
                $('#exportExcel').off('click.dt').on('click.dt', () => {
                    if (this.datatable) {
                        this.datatable.button('.buttons-excel').trigger();
                    }
                });

            } catch (err) {
                console.error('DataTable initialization failed:', err);
            }
        },


        openPaymentDateModal(claim) {
            this.isMarkAsPaid = false;
            this.isOpenModal = true;
            this.editData = claim;
        },

        openRequestChangeModal(claim) {
            this.requestChangeModal = true;
            this.editData = claim;
        },

        openFilterModal() {
            this.filterModal = true;
        },

        isSubmitted(claim) {
            return claim.status === "Submitted";
        },

        onChangeDate(e, type) {
            if (type === 'from') {
                this.date_from = e.target.value;
            } else {
                this.date_to = e.target.value;
            }
        },

        filterApprovedClaims(status) {
            this.activeApprovedStatus = status;
            this.selectedItems = [];
            this.selectAll = false;

            if ($.fn.DataTable.isDataTable("#approved_claim_tbl")) {
                $("#approved_claim_tbl").DataTable().destroy();
            }

            switch (status) {
                case "":
                    this.approved_claims = this.all_approved_claims;
                    break;
                case "Pending":
                    this.approved_claims = this.pending_approved_claims;
                    break;
                case "Submitted":
                    this.approved_claims = this.submitted_approved_claims;
                    break;
                case "Paid":
                    this.approved_claims = this.paid_approved_claims;
                    break;
                default:
                    this.approved_claims = this.all_approved_claims;
            }

            this.$nextTick(() => {
                this.initializeApprovedClaimsDatatable();
            });

        },

        openMarkAsPaidModal() {
            console.log("Opening Mark as Paid Modal");
            this.isMarkAsPaid = true;
        },

        openSuccessModal() {
            this.successModal = true;
        },

        async handleMarkAsPaid() {
            if (!this.datePaid) {
                return swal({
                    icon: "error",
                    title: "Error",
                    text: "Please select a date."
                });
            }
            if (this.selectedItems.length < 1) {
                return swal({
                    icon: "error",
                    title: "Error",
                    text: "Please tick one of the box."
                });
            }

            const request = {
                claim_payment_ids: this.selectedItems,
                payment_date: this.datePaid
            };

            try {
                const response = await markAsPaid(request);
                if (response.data.success) {
                    swal({
                        icon: "success",
                        text: response.data.message
                    });
                }
                this.fetchApproveClaim();
                this.isOpenModal = false;
                this.datePaid = null;
                this.isMarkAsPaid = false;
            } catch (error) {
                console.error(error);
            }
        },

        async addDate() {
            try {
                const request = {
                    payment_date: this.datePaid
                };
                const response = await updatePaymentDate(request, this.editData.id);
                if (response.data.success) {
                    swal({
                        icon: "success",
                        text: response.data.message
                    });
                    this.datePaid = null;
                    this.editData = null;
                    this.isOpenModal = false;
                    this.fetchApproveClaim();
                }
            } catch (error) {
                console.error(error);
            }
        },

        async handleRequestChange() {
            try {
                const response = await requestChange(this.editData.id, { payment_type: this.editData.payment_type.id == 1 ? 2 : 1 });
                if (response.data.success) {
                    this.successModal = true;
                    this.requestChangeModal = false;
                    this.editData = null;
                    this.fetchApproveClaim();
                } else {
                    swal({
                        icon: "error",
                        text: response.data.message
                    }).then(() => {
                        this.fetchApproveClaim();
                    })
                }
            } catch (error) {
                swal({
                    icon: "error",
                    text: error.message || String(error)
                })
            }
        },

        handleSubmit() {
            if (this.isMarkAsPaid) {
                this.handleMarkAsPaid();
            } else {
                this.addDate();
            }
        },

        handleDateChange(event) {
            this.datePaid = event.target.value;
        },
    },

    mounted() {
        this.fetchApproveClaim();
    },
}


</script>